import React from "react";
import _ from "lodash";
import { formatTextWithFallback, getLocalDateTime } from "../../../helpers/helpers";

function BCAReportExpansionComponent({ data }) {
  return (
    <>
      <div className="table-expaned-data">
        <div className="item">
          Profile ID <div className="value">{formatTextWithFallback(data?.profileId)}</div>
        </div>
        <div className="item">
          Nationality
          <div className="value">
            {formatTextWithFallback(data?.nationalityFull)}
          </div>
        </div>
        <div className="item">
          Designation <div className="value">{formatTextWithFallback(data?.designation)}</div>
        </div>
        <div className="item">
          Contract{" "}
          <div className="value">
            {formatTextWithFallback(data?.contract?.name)}
          </div>
        </div>
        <div className="item">
          Company <div className="value">{formatTextWithFallback(data?.company?.name)}</div>
        </div>
      </div>
    </>
  );
}

export default BCAReportExpansionComponent;
